import React from 'react';
import { Route, Switch } from 'react-router-dom';

import { TransitionGroup } from 'react-transition-group';

import CssTransition from '../../components/Transition/CssTransition';
import TransitionGroupContainer from '../../components/Transition/TransitionGroupContainer';

import StandardFrontCard from '../SingleAction/SingleActionDetails';
import RepStanceDetails from './RepStanceDetails';

const StartCard = StandardFrontCard('checkrepposition');

const RepStance = () => (
    <Route
        render={({ location }) => (
            <TransitionGroup component={TransitionGroupContainer}>
                <CssTransition key={location.pathname} timeoutInMs={650}>
                    <Switch location={location}>
                        <Route
                            path="/checkrepposition/start"
                            name="RepStanceStart"
                            exact
                            component={StartCard}
                        />
                        <Route
                            path="/checkrepposition"
                            name="RepStanceDetails"
                            exact
                            component={RepStanceDetails}
                        />
                    </Switch>
                </CssTransition>
            </TransitionGroup>
        )}
    />
);

export default RepStance;
